import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "flex items-center justify-center p-6 min-h-screen bg-indigo-800"
};
var _hoisted_2 = {
  "class": "w-full max-w-md"
};
var _hoisted_3 = {
  "class": "px-10 py-12"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "text-center text-3xl font-bold"
}, "Welcome Back!", -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  "class": "mt-6 mx-auto w-24 border-b-2"
}, null, -1);
var _hoisted_6 = {
  "class": "flex items-center mt-6 select-none",
  "for": "remember"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Remember Me", -1);
var _hoisted_8 = {
  "class": "flex px-10 py-4 bg-gray-100 border-t border-gray-100"
};
var _hoisted_9 = /*#__PURE__*/_createTextVNode("Login");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_logo = _resolveComponent("logo");
  var _component_text_input = _resolveComponent("text-input");
  var _component_loading_button = _resolveComponent("loading-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "Login"
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_logo, {
    "class": "block mx-auto w-full max-w-xs fill-white",
    height: "50"
  }), _createElementVNode("form", {
    "class": "mt-8 bg-white rounded-lg shadow-xl overflow-hidden",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(function () {
      return $options.login && $options.login.apply($options, arguments);
    }, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createVNode(_component_text_input, {
    modelValue: $data.form.email,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.email = $event;
    }),
    error: $data.form.errors.email,
    "class": "mt-10",
    label: "Email",
    type: "email",
    autofocus: "",
    autocapitalize: "off"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.password,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.password = $event;
    }),
    error: $data.form.errors.password,
    "class": "mt-6",
    label: "Password",
    type: "password"
  }, null, 8, ["modelValue", "error"]), _createElementVNode("label", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    id: "remember",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.remember = $event;
    }),
    "class": "mr-1",
    type: "checkbox"
  }, null, 512), [[_vModelCheckbox, $data.form.remember]]), _hoisted_7])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_loading_button, {
    loading: $data.form.processing,
    "class": "btn-indigo ml-auto",
    type: "submit"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_9];
    }),
    _: 1
  }, 8, ["loading"])])], 32)])])], 64);
}